
import styled from 'styled-components';

import { Flex, Text } from '@amzn/storm-ui';

export const ProfileDetailsFlexContainer = styled(Flex) <{ isOpen?: boolean }>`
  padding: 0.75rem 0.75rem;
  align-items: center;
  background-color: ${({ isOpen, theme }) =>
    isOpen ? theme.color.gray[700] : 'transparent'};
  cursor: pointer;
`;
export const ProfileIcon = styled(Text)`
  padding: 0.5rem;
  font-weight: bold;
  border-radius: 50%;
  margin-right: 0.5rem;
  background-color: ${({ theme }) => theme.color.gray[0]};
`;